import { render, staticRenderFns } from "./InsurenceInfo.vue?vue&type=template&id=5366fd10&"
import script from "./InsurenceInfo.vue?vue&type=script&lang=js&"
export * from "./InsurenceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports